<template>
  <div v-if="item">
    <fields-list :item="item" :fields="fields" />

    <variants :id="item.id" />
    <div class="save-group">
      <button class="btn btn-warning btn-icon" @click="updateItem">
        <span class="ti-save"></span>{{ "save" | setText("Сохранить") }}
      </button>
    </div>
  </div>
</template>
<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";
import Variants from "./Variants.vue";

export default {
  components: { Variants },
  data: () => ({
    cardLink: "tariffs",
    cardSetLink: "tariffs",
    item: null,
    fields: [
      {
        key: "price_from",
        col: "col-6",
        label: "Цена от",
        labelKey: "price_from",
        type: "field",
        textType: "number",
      },
      {
        key: "price_till",
        col: "col-6",
        label: "Цена до",
        labelKey: "price_till",
        type: "field",
        textType: "number",
      },
      {
        key: "name",
        col: "col-12",
        label: "Название",
        labelKey: "name",
        isMultiLang: true,
        type: "field",
      },
      {
        key: "description",
        col: "col-12",
        label: "Описание",
        labelKey: "description",
        isMultiLang: true,
        type: "textarea",
      },
      {
        label: "Выберите сервис",
        key: "service",
        labelKey: "select_service",
        type: "select",
        modal: "service",
        selectKey: "name",
      },
    ],
  }),

  props: ["id"],
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(
        this.cardSetLink,
        this.item,
        this.fields
      );
    },
  },
};
</script>
<style>
</style>
